const DsfLoginUser = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_login_module" */ "./loginTemplate/loginUser"));
const DsfLoginQuick = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_login_module" */ "./loginTemplate/loginQuick"));
const DsfLoginIn = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_login_module" */ "./loginTemplate/loggedIn"));
const DsfPlatformLogin = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_pc_login_module" */ "./login.vue"));

const DsfPlatformForgotPassword = dsf.defineAsyncComponent("DsfPlatformForgotPassword", () => {
  return import(/*webpackChunkName:"platform_pc_login_module"*/ "./forgotPassword.vue");
});
const DsfPlatformAlterPassword = dsf.defineAsyncComponent("DsfPlatformAlterPassword", () => {
  return import(/*webpackChunkName:"platform_pc_login_module"*/ "./alterPassword.vue");
});

export default {
  install(Vue) {
    Vue.component("DsfLoginUser", DsfLoginUser);
    Vue.component("DsfLoginQuick", DsfLoginQuick);
    Vue.component("DsfLoginIn", DsfLoginIn);
    Vue.component("DsfPlatformLogin", DsfPlatformLogin);
    Vue.component("DsfPlatformForgotPassword", DsfPlatformForgotPassword);
    Vue.component("DsfPlatformAlterPassword", DsfPlatformAlterPassword);
  }
};
